export const SECTION_IDS = [
  "workflow", "where", "uses-game", "uses-site", "uses-video", "uses-freelance",
  "uses-more", "share", "audience", "closer", "pricing", "install", "footer",
] as const;

export type SectionId = (typeof SECTION_IDS)[number];
export type MarketingViewport = "desktop" | "mobile";
export type MarketingMotion = "full" | "reduced";

export interface MarketingRenderInput {
  scrollY: number;
  now: number;
  viewport: MarketingViewport;
  motion: MarketingMotion;
}

export interface MarketingFrame {
  travelPx: number;
  progress: number;
  handoff: number;
  direction: -1 | 0 | 1;
  activeSection: SectionId;
  sections: Record<SectionId, { progress: number }>;
  viewport: MarketingViewport;
  motion: MarketingMotion;
}

export interface MarketingLayout {
  viewportHeight: number;
  routeHeight: number;
  maxTravel: number;
  sections: Record<SectionId, { startPx: number; endPx: number }>;
}

export interface PresentationSnapshot {
  activeSection: SectionId;
  visible: boolean;
  travelPx: number;
}

export interface SubsystemSnapshot { state: "static" | "managed"; }

export interface ProductProofsSnapshot extends SubsystemSnapshot {
  where: SubsystemSnapshot;
  uses: SubsystemSnapshot;
  share: SubsystemSnapshot;
}

export interface ExperienceSnapshot {
  frame: MarketingFrame;
  world: SubsystemSnapshot;
  presentation: PresentationSnapshot;
  proofs: ProductProofsSnapshot;
  offers: SubsystemSnapshot;
}
